import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hierarchical-multiselect" }
const _hoisted_2 = { class: "hierarchical-multiselect__selected-items" }
const _hoisted_3 = {
  key: 0,
  class: "hierarchical-multiselect__placeholder"
}
const _hoisted_4 = {
  key: 1,
  class: "hierarchical-multiselect__selected-text"
}
const _hoisted_5 = {
  key: 2,
  class: "hierarchical-multiselect__selected-text"
}
const _hoisted_6 = { class: "hierarchical-multiselect__selected-count" }
const _hoisted_7 = { class: "hierarchical-multiselect__dropdown-wrapper" }
const _hoisted_8 = { class: "hierarchical-multiselect__dropdown-footer" }
const _hoisted_9 = {
  key: 0,
  class: "hierarchical-multiselect__actions",
  ref: "globalContextMenuActions"
}
const _hoisted_10 = { class: "hierarchical-multiselect__search" }
const _hoisted_11 = {
  class: "hierarchical-multiselect__dropdown-body",
  ref: "listContainer"
}
const _hoisted_12 = ["data-index", "data-key"]
const _hoisted_13 = {
  key: 1,
  class: "hierarchical-multiselect__empty"
}
const _hoisted_14 = {
  key: 0,
  class: "invalid-msg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_TreeMultiselectOption = _resolveComponent("TreeMultiselectOption")!
  const _component_GlobalContextMenu = _resolveComponent("GlobalContextMenu")!
  const _component_LocalContextMenu = _resolveComponent("LocalContextMenu")!
  const _component_CombinedContextMenu = _resolveComponent("CombinedContextMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["hierarchical-multiselect__input", {
        'hierarchical-multiselect__input_error': _ctx.v$.modelValue.$error && _ctx.v$.modelValue.$invalid,
        'hierarchical-multiselect__input_disabled': _ctx.disabled,
      }]),
      ref: "inputContainer",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.getValue.length === 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.placeholder), 1))
          : (_ctx.getValue.length === 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createElementVNode("span", null, _toDisplayString(_ctx.getValue[0]?.label ?? ''), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "Выбрано", -1)),
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.getValue.length), 1)
                ])
              ]))
      ]),
      (_ctx.getValue.length > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "hierarchical-multiselect__clear hierarchical-multiselect__clear_value",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearValue && _ctx.clearValue(...args)), ["stop"]))
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["hierarchical-multiselect__arrow", { 'hierarchical-multiselect__arrow--up': _ctx.isOpen }])
      }, null, 2)
    ], 2),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["hierarchical-multiselect__dropdown", { 'hierarchical-multiselect__dropdown--up': _ctx.dropdownState.isDropdownUp }]),
            ref: "dropdownContainer"
          }, [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.getIsShowActionButton)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_ButtonComponent, {
                      class: "hierarchical-multiselect__actions-button",
                      mod: "only-blue-text",
                      buttonType: "button",
                      onClick: _withModifiers(_ctx.handleActionsButtonClick, ["stop"])
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("Действия", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 512))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  ref: "searchInput",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  type: "text",
                  placeholder: "Поиск...",
                  class: "hierarchical-multiselect__search-input"
                }, null, 512), [
                  [_vModelText, _ctx.searchQuery]
                ]),
                (_ctx.searchQuery.length > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "hierarchical-multiselect__clear hierarchical-multiselect__clear_search",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearSearchQuery && _ctx.clearSearchQuery(...args)), ["stop"]))
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.getVisibleOptions.length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    style: _normalizeStyle({ height: _ctx.getTotalSize, position: 'relative' })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVirtualRows, (virtualRow) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: String(virtualRow.key),
                        ref_for: true,
                        ref: _ctx.measureElement,
                        "data-index": virtualRow.index,
                        "data-key": _ctx.getItemKey(_ctx.getVisibleOptions[virtualRow.index]),
                        style: _normalizeStyle({
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                transform: `translateY(${virtualRow.start}px)`,
              })
                      }, [
                        _createVNode(_component_TreeMultiselectOption, {
                          item: _ctx.getVisibleOptions[virtualRow.index],
                          selectedValueSet: _ctx.getSelectedValueSet,
                          expandedItems: _ctx.expandedItems,
                          isClickAnyNode: _ctx.getIsCombinedModalMode,
                          onToggleSelection: _ctx.toggleSelection,
                          onToggleExpanded: _ctx.toggleExpanded,
                          onOpenContextMenu: _ctx.openContextMenu
                        }, null, 8, ["item", "selectedValueSet", "expandedItems", "isClickAnyNode", "onToggleSelection", "onToggleExpanded", "onOpenContextMenu"])
                      ], 12, _hoisted_12))
                    }), 128))
                  ], 4))
                : (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.getEmptyStateText), 1))
            ], 512)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    (_ctx.v$.modelValue.$error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (_ctx.v$.modelValue.$invalid)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.textError), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.getIsShowGlobalContextMenu)
      ? (_openBlock(), _createBlock(_component_GlobalContextMenu, {
          key: 1,
          isVisible: _ctx.globalContextMenu.isVisible,
          position: _ctx.globalContextMenu.position,
          additionalMenu: _ctx.getAdditionalMenu,
          onAction: _ctx.handleGlobalContextMenuAction,
          onClose: _ctx.closeGlobalContextMenu,
          isFlatTree: _ctx.getIsFlatTree,
          isSingleMode: _ctx.isSingleMode
        }, null, 8, ["isVisible", "position", "additionalMenu", "onAction", "onClose", "isFlatTree", "isSingleMode"]))
      : _createCommentVNode("", true),
    (_ctx.getIsShowLocalContextMenu && !_ctx.isSingleMode)
      ? (_openBlock(), _createBlock(_component_LocalContextMenu, {
          key: 2,
          isVisible: _ctx.localContextMenu.isVisible,
          position: _ctx.localContextMenu.position,
          isShowChildrenActions: _ctx.getIsShowChildrenActions,
          onAction: _ctx.handleLocalContextMenuAction,
          onClose: _ctx.closeLocalContextMenu
        }, null, 8, ["isVisible", "position", "isShowChildrenActions", "onAction", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.getIsCombinedModalMode)
      ? (_openBlock(), _createBlock(_component_CombinedContextMenu, {
          key: 3,
          isVisible: _ctx.combinedContextMenu.isVisible,
          position: _ctx.combinedContextMenu.position,
          isFlatTree: _ctx.getIsFlatTree,
          isSingleMode: _ctx.isSingleMode,
          additionalMenu: _ctx.getAdditionalMenu,
          isShowChildrenActions: _ctx.getIsShowChildrenActions,
          onGlobalAction: _ctx.handleGlobalContextMenuAction,
          onLocalAction: _ctx.handleLocalContextMenuAction,
          onClose: _ctx.closeCombinedContextMenu
        }, null, 8, ["isVisible", "position", "isFlatTree", "isSingleMode", "additionalMenu", "isShowChildrenActions", "onGlobalAction", "onLocalAction", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}